<template>
  <application-layout>
    <v-container>
      <v-layout
        v-if="viewLoading"
        class="pa-5"
        column
        align-center
        justify-center
      >
        <v-progress-circular
          :size="70"
          :width="7"
          indeterminate
        />
      </v-layout>
      <div v-else>
        <v-layout>
          <v-flex>
            <tenant-details :facility="facility" />
          </v-flex>
        </v-layout>
        <v-tabs v-model="tab">
          <v-tab
            data-testid="ar-tenant-active-rentals-tab"
            class="ar-tenant-active-rentals-tab"
          >
            Active Rentals
          </v-tab>
          <v-tab
            data-testid="ar-tenant-payment-plans-tab"
            class="ar-tenant-payment-plans-tab"
          >
            Payment Plans
          </v-tab>
          <v-tab
            data-testid="ar-tenant-promise-to-pay-tab"
            class="ar-tenant-promise-to-pay-tab"
          >
            Promise-to-Pay
          </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
          <v-tab-item class="mt-4" eager>
            <tenant-rentals
              :convenienceFeeStatus="convenienceFeeStatus"
              @paymentSuccess="paymentSuccess"
              @billingUpdate="getLedgerInfo"
            />
          </v-tab-item>
          <v-tab-item class="mt-4" eager>
            <tenant-plans :activeTab="tab" @billingUpdate="getLedgerInfo" />
          </v-tab-item>
          <v-tab-item class="mt-4" eager>
            <tenant-promises :activeTab="tab" @billingUpdate="getLedgerInfo" />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-container>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout";
import TenantDetails from "@/components/TenantDetails";
import TenantPlans from "@/modules/accounts-receivable/views/tenant/partials/TenantPlans";
import TenantPromises from "@/modules/accounts-receivable/views/tenant/partials/TenantPromises";
import TenantRentals from "@/components/tenant-rentals/TenantRentals";
import { mapState } from "vuex";

export default {
  name: "ARTenant",
  components: { ApplicationLayout, TenantPlans, TenantPromises, TenantRentals, TenantDetails },
  data() {
    return {
      balanceDetailsLoading: false,
      convenienceFeeLoading: false,
      convenienceFeeStatus: "",
      facility: "",
      facilityInfoLoading: false,
      ledgersLoading: false,
      loadingMessage: "",
      initData: {
        facilityId: this.$route.params.facilityId,
        tenantId: this.$route.params.tenantId
      },
      paymentPlansLoading: false,
      promiseToPaysLoading: false,
      tab: 0,
      tenantInfoLoading: false
    };
  },
  methods: {
    getBalanceDetails() {
      this.balanceDetailsLoading = true;
      this.$store.dispatch("getBalanceDetails", this.initData)
        .then(() => {
          this.balanceDetailsLoading = false;
        })
        .catch(err => {
          this.balanceDetailsLoading = false;
          this.$store.dispatch("handleError", err);
        });
    },

    getConvenienceFeeLastWaived() {
      this.convenienceFeeLoading = false;
      this.$store.dispatch("convenienceFeeLastWaived", this.initData)
        .then(resp => {
          this.convenienceFeeLoading = false;
          this.convenienceFeeStatus = resp.data.last_waived;
        })
        .catch(err => {
          this.convenienceFeeLoading = false;
          this.$store.dispatch("handleError", err);
        });
    },

    getLedgerInfo() {
      this.ledgersLoading = true;
      this.$store.dispatch("getLedgerInfo", this.initData)
        .then(() => {
          this.ledgersLoading = false;
        })
        .catch(err => {
          this.ledgersLoading = false;
          this.$store.dispatch("handleError", err);
        });
    },

    getFacilityInfo() {
      this.facilityInfoLoading = true;
      this.$store.dispatch("getFacility", this.$route.params.facilityId)
        .then(resp => {
          this.facility = resp.data.facility;
          this.facilityInfoLoading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.facilityInfoLoading = false;
        })
      ;
    },

    getAllPaymentPlans() {
      this.paymentPlansLoading = true;
      let payload = {
        facilityId: this.$route.params.facilityId,
        tenantId: this.$route.params.tenantId
      };

      this.$store.dispatch("getAllPaymentPlansForTenant", payload)
        .then(() => {
          this.paymentPlansLoading = false;
        })
        .catch(err => {
          this.paymentPlansLoading = false;
          this.$store.dispatch("handleError", err);
        });
    },

    getAllPromiseToPays() {
      this.promiseToPaysLoading = true;
      let payload = {
        facilityId: this.$route.params.facilityId,
        tenantId: this.$route.params.tenantId
      };

      this.$store.dispatch("getAllPromisesToPayForTenant", payload)
        .then(() => {
          this.promiseToPaysLoading = false;
        })
        .catch(err => {
          this.promiseToPaysLoading = false;
          this.$store.dispatch("handleError", err);
        });
    },

    getTenantInfo() {
      this.tenantInfoLoading = true;
      this.$store.dispatch("getTenantInfo", this.initData)
        .then(resp => {
          this.tenantInfoLoading = false;
          this.tenant = resp.data;
          this.$store.commit("changingTenant", false);
        })
        .catch(err => {
          this.tenantInfoLoading = false;
          this.$store.dispatch("handleError", err);
        });
    },

    paymentSuccess() {
      this.getLedgerInfo();
      this.getBalanceDetails();
    },

    initializeArTenant() {
      this.getTenantInfo();
      this.getLedgerInfo();
      this.getFacilityInfo();
      this.getBalanceDetails();
      this.getAllPaymentPlans();
      this.getAllPromiseToPays();
      this.getConvenienceFeeLastWaived();
    }
  },

  computed: {
    ...mapState({
      info: state => state.tenant.info
    }),

    viewLoading() {
      return this.balanceDetailsLoading ||
        this.convenienceFeeLoading ||
        this.facilityInfoLoading ||
        this.ledgersLoading ||
        this.promiseToPaysLoading ||
        this.paymentPlansLoading ||
        this.tenantInfoLoading;
    }
  },

  created() {
    this.$store.commit("resetAccountsReceivableState");
    this.initializeArTenant();
  }
};
</script>
